import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    priceListdata:{}, //出价列表
    alllotlist:[], //根据拍卖会查询到的标的列表
    lotInfo:{}, // 某个标的详情
    noticeInfo:{},//某个拍卖公告详情
    auctionmeet:{},//某个拍卖会详情
    lotId:'',
    keyWord:'',
    pagetype:localStorage.getItem("pagetype")?JSON.parse(localStorage.getItem("pagetype")):null, //页面搜索类型数据
    userinfo:localStorage.getItem("userinfo")?JSON.parse(localStorage.getItem("userinfo")):null,
    meetingstatusList:[{key:0,val:'即将开始'},{key:1,val:'正在进行'},{key:2,val:'已结束'}], //拍卖会阶段
    modelist:[{key:0,val:'同步拍'},{key:1,val:'网络拍'}], //拍卖形式
    biaodistatuslist:[{key:1,val:'正在进行'},{key:0,val:'即将开始'},{key:3,val:'成交'},{key:2,val:'流拍'},{key:5,val:'撤拍'},{key:4,val:'暂停'}],
    attributelist:[{key:1,val:'司法委托'},{key:2,val:'政府委托'}], //标的委托类型
    logotitle: localStorage.getItem("logotitle")?localStorage.getItem("logotitle"):-1,
  },
  getters: {
    getnoticeInfo(state){
      return state.noticeInfo
    },
    getpriceListdata(state){
      return state.priceListdata
    },
    getalllotlist(state){
      return state.alllotlist
    },
    getlotInfo(state){
      return state.lotInfo
    },
    getauctionmeet(state){
      return state.auctionmeet
    },
    getlotId(state){
      return state.lotId
    },
    getKeyWord(state){
      return state.keyWord
    },
    getLogotitle (state) {
      return state.logotitle
    },
    getuserinfo (state) {
      return state.userinfo
    },
    getpagetype (state) {
      return state.pagetype
    }
  },
  mutations: {
    setnoticeInfo(state, data){
      state.noticeInfo = data
    },
    setpriceListdata(state, arr){
      state.priceListdata = arr
    },
    setalllotlist(state, arr){
      state.alllotlist = arr
    },
    setlotInfo(state, data){
      state.lotInfo = data
    },
    setauctionmeet(state, data){
      state.auctionmeet = data
    },
    setlotId(state, id){
      state.lotId = id;
    },
    setKeyWord (state, val){
      state.keyWord = val;
    },
    setLogotitle (state, index) {
      localStorage.setItem("logotitle", index)
      state.logotitle = index;
    },
    setpagetype(state, data){
      localStorage.setItem("pagetype", JSON.stringify(data))
      state.pagetype = data
    },
    setUserinfo (state, data) {
      if(data){
        localStorage.setItem("userinfo", JSON.stringify(data))
        state.userinfo = data;
      }else{
        localStorage.setItem("userinfo", null);
        state.userinfo = null
      }
    }
  },
  actions: {
  },
  modules: {
  }
})
